$(document).ready(function(){
  /**
   *  Unwraps the embed div on iframes
   */
    $("#openSchedulingFrame").unwrap();

  // Enables popovers where present.
    $('[data-toggle="popover"]').popover();

});

// 
$('#schedule-modal').on('show.bs.modal', function (event) {
  let button = $(event.relatedTarget);
  let url = button.data('iframe');
  var modal = $(this)
  modal.find('.modal-body').html('<iframe style="width:100%;height:70vh;" src="' + url + '"></iframe>')
});

let button = $('#expand-all');
let main = $('#accordion-main');

button.on('click', function() {
    if (button.text() === 'Expand All') {
        $('#accordion-main .collapse').removeAttr("data-parent");
        $('#accordion-main .collapse').collapse('show');
        button.text('Collapse All');
    } else {
        $('#accordion-main .collapse').collapse('hide');
        button.text('Expand All');
    }
});

main.on('shown.bs.collapse', function() {
    // $('.btn.btn-link').not('.collapsed').children().text('Collapse');
    button.text('Collapse All');
});

main.on('hidden.bs.collapse', function(e) {
    // $('.collapsed span.accordion-indicator').text('Expand');

    if ($('.btn.btn-link').not('.collapsed').length === 0) {
        button.text('Expand All');
    }
});

/**
 * Hide body and emergency banner (if visible) when opening mobile nav
 */
let mobileNavButton = $('#dropdownMenuMobile');
mobileNavButton.on('show.bs.collapse', function(e) {
  $('#emergency-banner,body > div.wrapper').addClass('d-none');
});
mobileNavButton.on('hidden.bs.collapse', function(e) {
  $('#emergency-banner,body > div.wrapper').removeClass('d-none');
});

// Adding in an attr for iframes that is stripped by HTMLPurifier.
// These iframes  are mainly on Urgent Care Location pages, but may be elsewhere
// See https://ochsner-web.monday.com/boards/159749393/pulses/12290475582
// Added 6/22/26, maybe slate for removal
window.addEventListener('load', () => {
  const onMyWayFrame = document.getElementById('onMyWayFrame');
  if(onMyWayFrame) {
    onMyWayFrame.setAttribute('allow', 'geolocation');
  }
})
